// in src/App.js
import React, { Component } from 'react';
import Layout from './Layout';
import Menu from './Menu';
import Dashboard from './dashboard';
import { Admin, Resource, Login } from 'react-admin';

import { BusinessList, BusinessIcon } from './business';
import { UserList, UserIcon } from './users';

import restClient, { httpClient } from './restClient';
import authProvider from './authProvider';

const client = restClient(httpClient);

class App extends Component {
  render() {
    return (
      <Admin
        title="Seppo Reporting"
        dataProvider={client}
        authProvider={authProvider}
        dashboard={Dashboard}
        appLayout={Layout}
        loginPage={Login}
        menu={Menu}
      >
        <Resource
          name="users"
          list={UserList}
          icon={UserIcon}
          options={{ label: 'Users' }}
        />
        <Resource
          name="businesses"
          list={BusinessList}
          icon={BusinessIcon}
          options={{ label: 'Business' }}
        />
      </Admin>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js